// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__1DUO4","choiceBoxes":"toolbarselects_choiceBoxes__3EXM5","simpleField":"toolbarselects_simpleField__1lHxZ"};